import React, { FC, ReactNode } from "react"
import styled from "styled-components"
import { UserMenu } from "../../app/nav/UserMenu"

type MasterLayoutProps = {
  header: ReactNode
  children: ReactNode
  footer?: ReactNode
}

const FooterContainer = styled.div`
  margin-top: auto;
`
const footerSupportClasses = "flex flex-column h-100"

const MasterLayout: FC<MasterLayoutProps> = ({ header, children, footer }: MasterLayoutProps) => (
  <div className="w-100 flex flex-column items-center ph45-l ph35-m ph35-s">
    <div className={`mw-968-l mw-600-m w-100${footer?` ${footerSupportClasses}`:''}`}>
      <UserMenu className="dn db-ns" />
      {header}
      <div className="mt4 mt35-s mb45-ns mb55">{children}</div>
      {footer && <FooterContainer>{footer}</FooterContainer>}
    </div>
  </div>
)

export { MasterLayout }
